import { TextMediumSM } from "../../../../../Components/Text/MediumText";
import Title from "./Title";


const IndexBidding = () =>{
    return(
        <>
        <TextMediumSM content="Bidding" />
        <div className='w-full flex flex-wrap justify-center md:justify-start  items-center overflow-y-scroll'>
        
         <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <Title />
         </div>
         </div>
         </>
    )
}

export default IndexBidding;